<template>
  <div class="submitted-deals">
    <div class="filterBox">
      <div class="filter" ref="operationRef">
        <div class="filter-item">
          <div class="filter-item-label">Time</div>
          <div class="filter-item-input">
            <a-date-picker v-model:value="filter.time" :allowClear="true" :getPopupContainer="() => $refs.operationRef"/>
            <!-- <artemisads-range-picker :allowClear="true" v-model:value="filter.time" :presets="RANGE_PRESETS"
               /> -->
          </div>
        </div>
        <div class="filter-item" ref="marketplaceRef">
          <div class="filter-item-label">Marketplace</div>
          <div class="filter-item-input">
            <artmisads-select
              v-model:value="filter.marketplace"
              style="width: 232px"
              :options="marketplaceOptions"
              :show-arrow="false"
              placeholder="All"
              allowClear
              :getPopupContainer="() => marketplaceRef"
            />
          </div>
        </div>
        <div class="filter-item" ref="brandRef">
          <div class="filter-item-label">Brand</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.brandName" placeholder="Brand" />
          </div>
        </div>
        
        <div class="filter-item" ref="brandRef">
          <div class="filter-item-label">BD</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.bd" placeholder="BD" />
          </div>
        </div>
        <!-- <div class="filter-item">
          <div class="filter-item-label">Content</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.dealContent" placeholder="Content" />
          </div>
        </div> -->
        <!-- <div class="filter-item">
          <div class="filter-item-label">SDID</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.dmSubmittedDealId" placeholder="SDID" />
          </div>
        </div> -->
        <div class="filter-item">
          <div class="filter-item-label">ASIN</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.asin" placeholder="ASIN" />
          </div>
        </div>
         <div class="filter-item" ref="statusRef">
          <div class="filter-item-label">status</div>
          <div class="filter-item-input">
            <artmisads-select v-model:value="filter.status" style="width: 232px" :options="statusOptions"
           :show-arrow="false" :filter-option="false" :not-found-content="null" placeholder="All"
            :getPopupContainer="() => $refs.statusRef"/>
          </div>
        </div>
        <div class="filter-item" ref="startsRef">
          <div class="filter-item-label">Starts On or After</div>
          <div class="filter-item-input">
            <a-date-picker v-model:value="filter.startDate" :allowClear="true" :disabled-date="disabledStartDate"
              :getPopupContainer="() => $refs.startsRef"/>
          </div>
        </div>
        <div class="filter-item" ref="endRef">
          <div class="filter-item-label">Ends On or Before</div>
          <div class="filter-item-input">
            <a-date-picker v-model:value="filter.endDate" :allowClear="true" :disabled-date="disabledEndDate"
              :getPopupContainer="() => $refs.endRef"/>
          </div>
        </div>
        <!-- <div class="filter-item">
           <div class="filter-item-label">BD</div>
          <div class="filter-item-input">
            <artmisads-input v-model:value="filter.brandName" placeholder="ASIN" />
          </div>
        </div> -->
      </div>
      <div class="btn-box">
        <artmisads-button type="primary" @click="handleReset">Reset</artmisads-button>
        <artmisads-button type="primary" @click="handleSearch">Search</artmisads-button>
      </div>
    </div>
    <div class="table-data">
      <div ref="mainRef" class="top">
        <a-dropdown :getPopupContainer="() => $refs.mainRef">
          <template #overlay>
            <artmisads-dropdown-menu @click="handleExportClick">
              <a-menu-item key="all">Export All Data</a-menu-item>
              <a-menu-item key="filter">Export with Filters</a-menu-item>
            </artmisads-dropdown-menu>
          </template>
          <artmisads-button-special class="export-btn">
            <svg class="icon daochu" aria-hidden="true">
              <use xlink:href="#icon-daochu"></use>
            </svg>
            <span class="btn-text">Export</span>
            <svg class="icon artmisads-select-down-icon" aria-hidden="true">
              <use xlink:href="#icon-jiantou-xia-cu"></use>
            </svg>
          </artmisads-button-special>
        </a-dropdown>
        <artmisads-button isSquare="true" @click="openQueryModal"
          >数据查询</artmisads-button
        >
        <artmisads-button isSquare="true" @click="onUpload"
          >上传CSV</artmisads-button
        >
         <!-- <artmisads-button isSquare="true" @click="onUpload"
          >上传人工提报</artmisads-button
        > -->
      </div>

      <artmisads-table :pagination="param" :columns="columns" :data-source="data" :change="onTableChange"
        :loading="load" :scroll="{ x: 2200, y: tableScrollHeight }">
        <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.key === 'amazonName'">
            {{ record.amazonName || '--' }}
          </template>
          <template v-if="column.key === 'dealContent'">
            <a-tooltip placement="top">
              <template #title>
                <span>{{ record.dealContent }}</span>
              </template>
              <div class="content">
                {{ record.dealContent || '--' }}
              </div>
            </a-tooltip>
          </template>
          <template v-if="column.key === 'finalPrice'">
            {{
              record.finalPrice
                ? `${CURRENCY_DATA_MAPPER[record.currency]}${record.finalPrice}`
                : '--'
            }}
          </template>
          <template v-if="column.key === 'fullPrice'">
            {{
              record.finalPrice
                ? `${CURRENCY_DATA_MAPPER[record.currency]}${record.fullPrice}`
                : '--'
            }}
          </template>
          <template v-if="column.key === 'time'">
            {{
              record.submitTime
                ? moment(record.submitTime).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
                : '--'
            }}
          </template>
          <template v-if="column.key === 'dealStartTime'">
            {{
              record.dealStartTime
                ? moment(record.dealStartTime).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
                : '--'
            }}
          </template>
          <template v-if="column.key === 'dealEndTime'">
            {{
              record.dealEndTime
                ? moment(record.dealEndTime).tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
                : '--'
            }}
          </template>
          <template v-if="column.key === 'action'">
            <a @click="copy(record)" v-if="record.status=='PUBLISHED'" style="padding-right: 10px;">
              Copy
            </a>
            <artmisads-select-button type="text" @click="view(record)" :disabled="returnDisabled(record)">
              View 
            </artmisads-select-button>
          </template>
        </template>
      </artmisads-table>
    </div>
    <!-- <manualReportingModel ref="manualReportingModelRef" @refresh="handleRefresh"/> -->
    <uploadModel ref="uploadModelRef" @refreshList="handleRefresh"/>
    <queryModal ref="queryModalRef" />
  </div>
</template>
<script setup>
import { AMAZON_CURRENCY_MAPPER, CURRENCY_DATA_MAPPER, COUNTRY_TIME_TZ, COUNTRY_BASE } from '~/contants/common'
import { ref } from 'vue'
import { publisherAdminApi } from '~/server/index'
import { RANGE_PRESETS } from '~/contants/reports'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import { copyToClipboard } from '~/utils'
import manualReportingModel from './manualReportingModel.vue'
import uploadModel from './uploadModel.vue'
import moment from 'moment'
import dayjs from 'dayjs'
import { message} from "ant-design-vue";
import { useUserInfoStore } from '@/storeData/index'
import queryModal from './queryModal.vue'

const timeRange = ref([])
const queryModalRef = ref(null)
const marketplaceRef = ref(null)
const marketplaceOptions = [
  { label: 'All', value: '' },
  ...COUNTRY_BASE.map((item) => ({
    label: item.host,
    value: item.host,
  })),
]
// setTimeout(() => {
//   queryModalRef.value.open()
// }, 100)
const store = useUserInfoStore()
const userInfo = store.userInfo
const timeZone = COUNTRY_TIME_TZ[userInfo.countryCode]|| 'US'

const manualReportingModelRef = ref(null)
const uploadModelRef = ref(null)
const param = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})
const statusOptions = ref([
  {
    label: 'All',
    value: ''
  },
  {
    label: 'SUCCESS',
    value: 'SUCCESS'
  },
  {
    label: 'GENERATED',
    value: 'GENERATED'
  },
  {
    label: 'PUBLISHED',
    value: 'PUBLISHED'
  },
  {
    label: 'FAILED',
    value: 'FAILED'
  },
])
const asins = ref('')
const startCreateTimestamp = ref('')
const endCreateTimestamp = ref('')
const startDealStartTimestamp = ref('')
const endDealStartTimestamp = ref('')
const filter = ref({
  time: '',
  brandName: "",
  dealContent: "",
  dmSubmittedDealId: "",
  bd: "",
  marketplace: "amazon.com",
})
const columns = ref([
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time',
    width: 200,

  },
  {
    title: 'Marketplace',
    dataIndex: 'marketplace',
    key: 'marketplace',
    width: 200,
  },
  {
    title: 'Amazon Seller Name',
    dataIndex: 'amazonName',
    key: 'amazonName',
    width: 200,
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',

  },
  {
    title: 'Asin',
    dataIndex: 'asin',
    key: 'asin',
  },
  {
    title: 'Category',
    dataIndex: 'artemisCategory',
    key: 'artemisCategory',

  },
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',

  },
  // {
  //   title: 'Content',
  //   dataIndex: 'dealContent',
  //   key: 'dealContent',

  // },
  {
    title: 'SDID',
    dataIndex: 'dmSubmittedDealId',
    key: 'dmSubmittedDealId',
  },
  {
    title: 'startDate',
    dataIndex: 'dealStartTime',
    key: 'dealStartTime'
  },
  {
    title: 'endDate',
    dataIndex: 'dealEndTime',
    key: 'dealEndTime'
  },
  {
    title: 'link',
    dataIndex: 'convertedUrl',
    key: 'convertedUrl'
  },
  {
    title: '原价',
    dataIndex: 'fullPrice',
    key: 'fullPrice'
  },
  {
    title: '现价',
    dataIndex: 'finalPrice',
    key: 'finalPrice'
  },
  {
    title: 'DealType',
    dataIndex: 'dealType',
    key: 'dealType'
  },
  {
    title: 'PromoCode',
    dataIndex: 'promoCode',
    key: 'promoCode'
  },
  {
    title: 'BD',
    dataIndex: 'bd',
    key: 'bd'
  },
  {
    title: 'BDNotes',
    dataIndex: 'bdNoteContent',
    key: 'bdNoteContent'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status'
  },
  // {
  //   title:'问题反馈',
  //   dataIndex:'status',
  //   key:'status'
  // },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action'
  }

])
const data = ref([])
const load = ref(false)

const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-data',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350,
})
const handleReset = () => {
  filter.value = {
    time: '',
    brandName: "",
    dealContent: "",
    dmSubmittedDealId: "",
    bd: "",
    marketplace: "",
  }
  param.value.current = 1
  startCreateTimestamp.value = ''
  endCreateTimestamp.value = ''
  startDealStartTimestamp.value = ''
  endDealStartTimestamp.value = ''

  getLsit()
}
const returnDisabled=(item)=>{
  if(item.aiAdminUrl){
    return false
  }else{
    return true
  }
}

const disabledEndDate = (current) => current && current < dayjs().startOf('day')
const disabledStartDate= (current) => current && current > dayjs().endOf('day')
const openQueryModal = () => {
  queryModalRef.value.open()
}
const handleSearch = () => {

  if (filter.value.time) {
    startCreateTimestamp.value = moment(moment(filter.value.time).tz(timeZone).format('YYYY-MM-DD')+' 00:00:00').valueOf()
    endCreateTimestamp.value =moment(moment(filter.value.time).tz(timeZone).format('YYYY-MM-DD')+' 23:59:59').valueOf()
  }
  if (filter.value.startDate) {
    startDealStartTimestamp.value =moment(moment(filter.value.startDate).tz(timeZone).format('YYYY-MM-DD')+' 00:00:00').valueOf()
  }
  if (filter.value.endDate) {
    endDealStartTimestamp.value = moment(moment(filter.value.endDate).tz(timeZone).format('YYYY-MM-DD')+' 23:59:59').valueOf()
  }
  // console.log(startCreateTimestamp.value,endCreateTimestamp.value,'数据')
  param.value.current = 1
  getLsit()
}
const onTableChange = (pagination) => {
  param.value.current = pagination.current
  param.value.pageSize = pagination.pageSize
  getLsit()
}
const getLsit = async () => {
  load.value = true
  const res = await publisherAdminApi.getSubmittedDeals({
    page: param.value.current,
    size: param.value.pageSize,
    startSubmitTimestamp: startCreateTimestamp.value,
    endSubmitTimestamp: endCreateTimestamp.value,
    startDealStartTimestamp: startDealStartTimestamp.value,
    endDealStartTimestamp: endDealStartTimestamp.value,
    asins: asins.value.value,
    ...filter.value,
  })
  load.value = false
  if (res.success) {
    data.value = res.data.data
    param.value.total = res.data.total
  }
}
const copy = (record) => {
  if(record.dmPublishedUrl){
  copyToClipboard(record.dmPublishedUrl)

  }else{
message.error('该项数据没配置dmPublishedUrl')
  }
}
const view = (record) => {
  if(record.aiAdminUrl){
  window.open(record.aiAdminUrl)

  }else{
message.error('该项数据没配置aiAdminUrl')

  }
}
const onUpload = () => {
  uploadModelRef.value.open()
  // manualReportingModelRef.value.open()
}
const handleExportClick = async ({ key }) => {
  let exportParams = {
    endReportDatePstTimestamp: moment().endOf('day').valueOf(),
    startReportDatePstTimestamp: moment().subtract(180, 'day').startOf('day').valueOf(),
  }, newExportParams = {}
  if (key === 'filter') {
    // console.log(filter.value.time,'数据')
    if (filter.value.time) {
    startCreateTimestamp.value = moment(moment(filter.value.time).tz(timeZone).format('YYYY-MM-DD')+' 00:00:00').valueOf()
    endCreateTimestamp.value =moment(moment(filter.value.time).tz(timeZone).format('YYYY-MM-DD')+' 23:59:59').valueOf()
  }
    exportParams = {
      startSubmitTimestamp: startCreateTimestamp.value,
      endSubmitTimestamp: endCreateTimestamp.value,
      asins: asins.value.value,
      ...filter.value,
    }
  }

  for (let item in exportParams) {
    if (exportParams[item]) {
      newExportParams[item] = exportParams[item]
    }
  }
  const finalParams = {
    qs: newExportParams,
    fileName: `Commissions-${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  }
  publisherAdminApi.dmSubmittedDealsExport(finalParams)
}
const handleRefresh = () => {
  handleReset()
}
// setTimeout(() => {
//   manualReportingModelRef.value.open()
// }, 1000)
getLsit()
</script>
<style scoped lang="less">
.top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  align-items: center;
  gap: 16px;
}

.content {
  width: 180px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* 限制行数为3 */
  -webkit-box-orient: vertical;
  overflow: hidden;

}

.submitted-deals {
  padding: 16px;

  width: 100%;
}

.table-data {

  border-radius: 8px;
  border: 1px solid #fff;
  border-radius: 12px;
  overflow: hidden;
  border-radius: 12px;
  background-color: var(--color-white);
  padding: 15px;

}

.filterBox {
  padding: 15px 16px;
  margin: 16px 0;
  flex-wrap: wrap;
  border-radius: 8px;
  background: #fff;
}

.btn-box {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.filter {
  display: flex;
  gap: 22px;
  flex-wrap: wrap;

  .filter-item {
    display: flex;
    gap: 10px;
    align-items: center;

    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      opacity: 0.9;
    }
  }
}
</style>
